import type { EChartsOption } from 'echarts';

/**
 * ApexCharts-shaped chart-option bag (legacy admin dashboard, #1143).
 *
 * ApexCharts is not a workspace dependency, so this stays a loose structural
 * map rather than importing the SDK's `ApexOptions`. The index signature keeps
 * it open for the chart properties the legacy dashboard mutates dynamically.
 */
export interface ChartType {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ApexCharts SDK is not installed; option bag is genuinely dynamic.
  [x: string]: any;
  series?: unknown;
  plotOptions?: unknown;
  stroke?: unknown;
  dataLabels?: unknown;
  chart?: unknown;
  legend?: unknown;
  colors?: unknown;
  labels?: unknown;
}

/**
 * ECharts option contract for the legacy dashboard (#1143).
 *
 * Aliased to the real `EChartsOption` from the installed `echarts` package
 * (a type-only import — erased at compile time, no runtime dependency added)
 * instead of the previous `any`-typed field bag. Every `EChartsOption` member
 * is optional, so existing `EChartType = {}` usages still type-check.
 */
export type EChartType = EChartsOption;

export interface Stat {
  title: string;
  icon: string;
  value: string;
}

export interface Chat {
  id?: number;
  name?: string;
  message?: string;
  image?: string;
  time?: string;
  align?: string;
  text?: string;
}

export interface Transaction {
  orderid: string;
  date: string;
  billingname: string;
  total: string;
  paymentstatus: string;
}
